import React, { useState, useEffect, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import { MultiSelect } from 'react-multi-select-component';
import { Container, Row, Col, Modal } from 'react-bootstrap';

import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { DOWNLOADULDRFS, STATIONGRID, GETDESTINATION, MONITORDOWNLOAD, MONITORLOADINGSTATION, MONITORUNLOADINGSTATION, MONITORTRUCKERS, MONITORCARRIERS } from '../../../../Utils/conts.js';
import { toast } from 'react-toastify';
import { decrypt } from '../../../../Utils/cryptoStorage.js';

const DownloadGrid = ({ download_area, onClose, download_sec }) => {

    // const user = localStorage.getItem('RFS');
    const isMounted = useRef(false);
    const [boardPoint, setBoardPoint] = useState([]);
    const [region, setRegion] = useState([]);
    const [offPoint, setOffPoint] = useState([]);
    const [getDestination, setGetDestination] = useState([]);
    const [getLoadingStn, setGetLoadingStn] = useState([]);
    const [getUnLoadingStn, setGetUnLoadingStn] = useState([]);
    const [getTruckerNames, setGetTruckerNames] = useState([]);
    const [authData, setAuthData] = useState();

    const [isModalOpen, setIsModalOpen] = useState(true);
    const [downloadData, setDownloadData] = useState({
        // status: [], start_date: '', end_date: '', boardPoint: [], offPoint: []
    });
    const statusOptions = [
        { value: 's', label: 'Scheduled' },
        { value: 't', label: 'To be Planned' },
        { value: 'p', label: 'Planning in Progress' },
        { value: 'f', label: 'Planning Finalized' },
    ];

    useEffect(() => {
        const ExtractSession = async () => {
            try {
                const encryptedData = sessionStorage.getItem('__A-');
                if (encryptedData) {
                    const data = await decrypt(encryptedData);
                    setAuthData(data);
                }
            } catch (error) {
                console.error("Session decrypt error:", error);
            } finally {
                // setAuthLoading(false);
            }
        };
        ExtractSession();
    }, []);

    const regionData = async () => {
        try {

            const res = await withRFSToken.post('kpi-chart/get-region-list', {})
                .then(function (res) {
                    const activeInnerData = res.data.response_data;
                    setRegion(activeInnerData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchData = async () => {
        try {

            const res = await withRFSToken.post(STATIONGRID, {})
                .then(function (res) {
                    const activeInnerData = res.data.response_data.Active;
                    const transformedData = activeInnerData ? activeInnerData.map(item => ({
                        // id: item.id,
                        value: item.id,
                        label: item.station_code,
                        address: item.station_addresses,
                    })) : []; // For multiselect
                    setBoardPoint(transformedData); // For multiselect
                    setOffPoint(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDestination = async () => {
        try {
            const res = await withRFSToken.post(GETDESTINATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchLoadingStn = async () => {
        try {

            const res = await withRFSToken.post(MONITORLOADINGSTATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetLoadingStn(innerData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchUnLoadingStn = async () => {
        try {

            const res = await withRFSToken.post(MONITORUNLOADINGSTATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetUnLoadingStn(innerData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchTruckerNames = async () => {
        try {
            let endPoint;
            if (authData?.module === "RFS") {
                endPoint = MONITORTRUCKERS;
            } else {
                endPoint = MONITORCARRIERS;
            }
            const res = await withRFSToken.post(endPoint, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // const transformedData = innerData ? innerData.map(item => ({
                    //     value: item.port_code,
                    //     label: item.port_code,
                    //     address: item.address,
                    //     station_id: item.station_id
                    // })) : [];
                    setGetTruckerNames(innerData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (isMounted.current) return;
        fetchData();
        regionData();
        fetchDestination();
        fetchTruckerNames();
        fetchLoadingStn();
        fetchUnLoadingStn();
        isMounted.current = true;
    }, []);

    const exportToExcel = async () => {
        let endPoint;
        let payload = {}
        let fileName = '';
        if (download_area == 'bt') {
            fileName = 'Truck Schedule (' + downloadData.start_date + ' - ' + downloadData.end_date + ')';
            endPoint = DOWNLOADULDRFS
            payload = { tab_name: download_sec, fields: downloadData }
            if (!downloadData.start_date && !downloadData.end_date) {
                toast.error("Please Select Start and End Date");
                return false;
            }
        } else if (download_area == 'to') {
            fileName = 'Truck Order (' + downloadData.truck_date + ')';
            endPoint = 'truck-order-download'
            payload = { tab_name: download_sec, fields: downloadData }
            if (!downloadData.start_date && !downloadData.end_date) {
                toast.error("Please Select Start and End Date");
                return false;
            }
        } else {
            fileName = download_sec + '-exported-data.xlsx';
            endPoint = MONITORDOWNLOAD
            // order_view,awb_view,vehicle_view',
            payload = { tab_name: download_sec, filters: downloadData }
        }

        try {
            const res = await withRFSToken.post(endPoint, payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    },
                    responseType: 'blob', // important for handling binary file download like Excel
                }
            ).then(response => {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
                handleModalClose();
            });
            // .then(function (res) {
            //     if (res.data.response_code == 200) {
            //         const fileUrl = res.data.response_data;
            //         // Create a temporary anchor element
            //         toast.success('Downloaded Successfully')
            //         const link = document.createElement('a');
            //         link.href = fileUrl;

            //         // Extract the filename from the URL if needed
            //         const filename = fileUrl.split('/').pop(); // Gets the last part of the URL

            //         // Set the download attribute with the filename
            //         link.setAttribute('download', filename);

            //         // Append the anchor to the body (necessary for the click to work in Firefox)
            //         document.body.appendChild(link);

            //         // Programmatically click the anchor to trigger the download
            //         link.click();

            //         // Clean up by removing the anchor from the DOM
            //         document.body.removeChild(link);
            //         handleModalClose();
            //     } else {
            //         toast.error(res.data.response_msg)
            //     }

            // });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        onClose();
    };

    const [formData, setFormData] = useState({});
    const options = [
        { label: 'a', value: 's' },
        { label: 'b', value: 's' },
        { label: 'c', value: 's' },
        { label: 'd', value: 's' },
    ]
    return (
        <>
            <Modal show={isModalOpen} onHide={handleModalClose} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>Download Filter</h3>
                    <p>{download_area == 'bt' ? 'Download excel file based on set filters below.' : 'Set filters below'}</p>
                    <div className='my-4 '>
                        {download_area == 'bt' ?
                            <>
                                <Form.Group as={Row}>
                                    <Col sm="12" className='mb-2'>
                                        <Form.Label>Status</Form.Label>
                                        <Select
                                            options={statusOptions}
                                            placeholder="Status"
                                            className='down_selct'
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                setDownloadData({ ...downloadData, status: selectedValues });
                                            }}
                                            isMulti
                                            name="status"
                                            value={statusOptions.find(value => value.value === downloadData.status)}
                                        />
                                    </Col>
                                    <Row className='pe-0'>
                                        <Col sm="6" className='mb-2'>
                                            <Form.Label>Start Date <span>*</span></Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="start_date"
                                                onChange={(event) => {
                                                    const startDate = event.target.value;  // Get selected start date
                                                    setDownloadData({ ...downloadData, start_date: startDate });  // Update state
                                                }}
                                                value={downloadData.start_date}  // Bind the start date to the state
                                                placeholder="Start Date"
                                            />
                                        </Col>
                                        <Col sm="6" className='mb-2 pe-0'>
                                            <Form.Label>End Date <span>*</span></Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="end_date"
                                                onChange={(event) => {
                                                    const endDate = event.target.value;  // Get selected end date
                                                    setDownloadData({ ...downloadData, end_date: endDate });  // Update state
                                                }}
                                                value={downloadData.end_date}  // Bind the end date to the state
                                                placeholder="End Date"
                                            />
                                        </Col>
                                    </Row>
                                    <Col sm="12" className='mb-2'>
                                        <Form.Label>BoardPoint</Form.Label>
                                        <Select
                                            options={boardPoint}
                                            placeholder="BoardPoint"
                                            className='down_selct'
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                setDownloadData({ ...downloadData, boardPoint: selectedValues });
                                            }}
                                            isMulti
                                            name="boardPoint"
                                            value={boardPoint.find(value => value.value === downloadData.boardPoint)}
                                        />
                                    </Col>
                                    <Col sm="12" className='mb-2'>
                                        <Form.Label>OffPoint</Form.Label>
                                        <Select
                                            options={offPoint}
                                            placeholder="OffPoint"
                                            className='down_selct'
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                setDownloadData({ ...downloadData, offPoint: selectedValues });
                                            }}
                                            isMulti
                                            name="offPoint"
                                            value={offPoint.find(value => value.value === downloadData.offPoint)}
                                        />
                                    </Col>
                                    <Col sm="12" className='mb-2'>
                                        <Form.Label>Region</Form.Label>
                                        <Select
                                            options={region}
                                            placeholder="Region"
                                            className='down_selct'
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                setDownloadData({ ...downloadData, region_setting_id: selectedValues });
                                            }}
                                            isMulti
                                            name="region_setting_id"
                                            value={region.find(value => value.value === downloadData.region_setting_id)}
                                        />
                                    </Col>
                                </Form.Group>
                            </>
                            : (download_area == 'airline' ?
                                <>
                                    <Row className='pe-0'>
                                        <Col sm="12" className='mb-2'>
                                            <Form.Label>Truck Date</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="truck_date"
                                                onChange={(event) => {
                                                    const startDate = event.target.value;  // Get selected start date
                                                    setDownloadData({ ...downloadData, truck_date: startDate });  // Update state
                                                }}
                                                value={downloadData.truck_date}  // Bind the start date to the state
                                                placeholder="Truck Date"
                                            />
                                        </Col>
                                        {/* <Col sm="6" className='mb-2 pe-0'> */}
                                        {/* <Form.Label>End Date</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="end_date"
                                                onChange={(event) => {
                                                    const endDate = event.target.value;  // Get selected end date
                                                    setDownloadData({ ...downloadData, end_date: endDate });  // Update state
                                                }}
                                                value={downloadData.end_date}  // Bind the end date to the state
                                                placeholder="End Date"
                                            /> */}
                                        {/* </Col> */}
                                    </Row>
                                    <Form.Group as={Row}>
                                        <Col sm="12" className='mb-2'>
                                            <Form.Label>Trucker Name</Form.Label>
                                            <MultiSelect
                                                options={getTruckerNames}
                                                value={getTruckerNames.filter(item => downloadData.trucker_name?.includes(item.value))}
                                                onChange={(selected) => {
                                                    const selectedIds = selected.map(item => item.value);
                                                    setDownloadData((prevFormData) => ({
                                                        ...prevFormData,
                                                        trucker_name: selectedIds
                                                    }));
                                                }}
                                                labelledBy="Select "
                                                className='multiselect'
                                            />
                                            {/* <Select
                                                options={statusOptions}
                                                placeholder="Condition Code"
                                                className='down_selct'
                                                onChange={(selected) => {
                                                    const selectedValues = selected ? selected.map(option => option.value) : [];
                                                    setDownloadData({ ...downloadData, status: selectedValues });
                                                }}
                                                isMulti
                                                name="status"
                                                value={statusOptions.find(value => value.value === downloadData.status)}
                                            /> */}
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Col sm="12" className='mb-2'>
                                            <Form.Label>Loading Station</Form.Label>
                                            <MultiSelect
                                                options={getLoadingStn}
                                                value={getLoadingStn.filter(item => downloadData.loading_station?.includes(item.value))}
                                                onChange={(selected) => {
                                                    const selectedIds = selected.map(item => item.value);
                                                    setDownloadData((prevFormData) => ({
                                                        ...prevFormData,
                                                        loading_station: selectedIds
                                                    }));
                                                }}
                                                labelledBy="Select "
                                                className='multiselect'
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Col sm="12" className='mb-2'>
                                            <Form.Label>Unloading Station</Form.Label>
                                            <MultiSelect
                                                options={getUnLoadingStn}
                                                value={getUnLoadingStn.filter(item => downloadData.unloading_station?.includes(item.value))}
                                                onChange={(selected) => {
                                                    const selectedIds = selected.map(item => item.value);
                                                    setDownloadData((prevFormData) => ({
                                                        ...prevFormData,
                                                        unloading_station: selectedIds
                                                    }));
                                                }}
                                                labelledBy="Select "
                                                className='multiselect'
                                            />
                                        </Col>
                                    </Form.Group>
                                </>
                                : (download_area == 'trucker' ?
                                    <>
                                        <Row className='pe-0'>
                                            <Col sm="12" className='mb-2'>
                                                <Form.Label>Truck Date</Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    name="truck_date"
                                                    onChange={(event) => {
                                                        const startDate = event.target.value;  // Get selected start date
                                                        setDownloadData({ ...downloadData, truck_date: startDate });  // Update state
                                                    }}
                                                    value={downloadData.truck_date}  // Bind the start date to the state
                                                    placeholder="Truck Date"
                                                />
                                            </Col>
                                            {/* <Col sm="6" className='mb-2 pe-0'> */}
                                            {/* <Form.Label>End Date</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="end_date"
                                                onChange={(event) => {
                                                    const endDate = event.target.value;  // Get selected end date
                                                    setDownloadData({ ...downloadData, end_date: endDate });  // Update state
                                                }}
                                                value={downloadData.end_date}  // Bind the end date to the state
                                                placeholder="End Date"
                                            /> */}
                                            {/* </Col> */}
                                        </Row>
                                        <Form.Group as={Row}>
                                            <Col sm="12" className='mb-2'>
                                                <Form.Label>Carrier Name</Form.Label>
                                                <MultiSelect
                                                    options={getTruckerNames}
                                                    value={getTruckerNames.filter(item => downloadData.carrier_name?.includes(item.value))}
                                                    onChange={(selected) => {
                                                        const selectedIds = selected.map(item => item.value);
                                                        setDownloadData((prevFormData) => ({
                                                            ...prevFormData,
                                                            carrier_name: selectedIds
                                                        }));
                                                    }}
                                                    labelledBy="Select "
                                                    className='multiselect'
                                                />
                                                {/* <Select
                                                options={statusOptions}
                                                placeholder="Condition Code"
                                                className='down_selct'
                                                onChange={(selected) => {
                                                    const selectedValues = selected ? selected.map(option => option.value) : [];
                                                    setDownloadData({ ...downloadData, status: selectedValues });
                                                }}
                                                isMulti
                                                name="status"
                                                value={statusOptions.find(value => value.value === downloadData.status)}
                                            /> */}
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row}>
                                            <Col sm="12" className='mb-2'>
                                                <Form.Label>Loading Station</Form.Label>
                                                <MultiSelect
                                                    options={getLoadingStn}
                                                    value={getLoadingStn.filter(item => downloadData.loading_station?.includes(item.value))}
                                                    onChange={(selected) => {
                                                        const selectedIds = selected.map(item => item.value);
                                                        setDownloadData((prevFormData) => ({
                                                            ...prevFormData,
                                                            loading_station: selectedIds
                                                        }));
                                                    }}
                                                    labelledBy="Select "
                                                    className='multiselect'
                                                />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row}>
                                            <Col sm="12" className='mb-2'>
                                                <Form.Label>Unloading Station</Form.Label>
                                                <MultiSelect
                                                    options={getUnLoadingStn}
                                                    value={getUnLoadingStn.filter(item => downloadData.unloading_station?.includes(item.value))}
                                                    onChange={(selected) => {
                                                        const selectedIds = selected.map(item => item.value);
                                                        setDownloadData((prevFormData) => ({
                                                            ...prevFormData,
                                                            unloading_station: selectedIds
                                                        }));
                                                    }}
                                                    labelledBy="Select "
                                                    className='multiselect'
                                                />
                                            </Col>
                                        </Form.Group>
                                    </>
                                    : (download_area == 'to' ?
                                        <>
                                            <Row className='pe-0'>
                                                <Col sm="12" className='mb-2 d-flex'>
                                                    <Form.Check
                                                        type="radio"
                                                        label="Active"
                                                        name="status"
                                                        value="true"
                                                        checked={downloadData.status == "A"}
                                                        id='status-1'
                                                        onChange={(e) => setDownloadData({ ...downloadData, status: 'A' })}
                                                    />
                                                    <Form.Check
                                                        type="radio"
                                                        label="Archive"
                                                        name="status"
                                                        value="false"
                                                        checked={downloadData.status == "R"}
                                                        id='status-2'
                                                        onChange={(e) => setDownloadData({ ...downloadData, status: 'R' })}
                                                    />
                                                </Col>
                                                <Row className='pe-0'>
                                                    <Col sm="6" className='mb-2'>
                                                        <Form.Label>Start Date <span>*</span></Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            name="start_date"
                                                            onChange={(event) => {
                                                                const startDate = event.target.value;  // Get selected start date
                                                                setDownloadData({ ...downloadData, start_date: startDate });  // Update state
                                                            }}
                                                            value={downloadData.start_date}  // Bind the start date to the state
                                                            placeholder="Start Date"
                                                        />
                                                    </Col>
                                                    <Col sm="6" className='mb-2 pe-0'>
                                                        <Form.Label>End Date <span>*</span></Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            name="end_date"
                                                            onChange={(event) => {
                                                                const endDate = event.target.value;  // Get selected end date
                                                                setDownloadData({ ...downloadData, end_date: endDate });  // Update state
                                                            }}
                                                            value={downloadData.end_date}  // Bind the end date to the state
                                                            placeholder="End Date"
                                                        />
                                                    </Col>
                                                </Row>
                                                {/* <Col sm="12" className='mb-2'>
                                                    <Form.Label>Truck Date</Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        name="truck_date"
                                                        onChange={(event) => {
                                                            const startDate = event.target.value;  // Get selected start date
                                                            setDownloadData({ ...downloadData, truck_date: startDate });  // Update state
                                                        }}
                                                        value={downloadData.truck_date}  // Bind the start date to the state
                                                        placeholder="Truck Date"
                                                    />
                                                </Col> */}
                                                <Col sm="12" className='mb-2'>
                                                    <Form.Label>BoardPoint</Form.Label>
                                                    <Select
                                                        options={boardPoint}
                                                        placeholder="BoardPoint"
                                                        className='down_selct'
                                                        onChange={(selected) => {
                                                            const selectedValues = selected ? selected.map(option => option.value) : [];
                                                            setDownloadData({ ...downloadData, boardPoint: selectedValues });
                                                        }}
                                                        isMulti
                                                        name="boardPoint"
                                                        value={boardPoint.find(value => value.value === downloadData.boardPoint)}
                                                    />
                                                </Col>
                                                <Col sm="12" className='mb-2'>
                                                    <Form.Label>OffPoint</Form.Label>
                                                    <Select
                                                        options={offPoint}
                                                        placeholder="OffPoint"
                                                        className='down_selct'
                                                        onChange={(selected) => {
                                                            const selectedValues = selected ? selected.map(option => option.value) : [];
                                                            setDownloadData({ ...downloadData, offPoint: selectedValues });
                                                        }}
                                                        isMulti
                                                        name="offPoint"
                                                        value={offPoint.find(value => value.value === downloadData.offPoint)}
                                                    />
                                                </Col>
                                            </Row>
                                        </>
                                        : ''
                                    )
                                )
                            )
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={exportToExcel}>
                        Download
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default DownloadGrid;